// POLYFILLS
// import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './polyfills'

// ASSETS
import './assets'

// STYLES
import './style/styles.scss'
import './style/styles-tailwind.scss'

// JS
import { createComponent } from '@aahdrien/needle'

import * as componentsNeedle from './components-needle'

Object.values(componentsNeedle).forEach(createComponent)

// ON MOUNT
// ACCESIBILITY
document.body.addEventListener('mousedown', () => {
  document.body.classList.add('using-mouse')
})

// Re-enable focus styling when Tab is pressed
document.body.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') document.body.classList.remove('using-mouse')
})

// RESPONSIVE
const handleResize = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

handleResize()

window.addEventListener('resize', handleResize)
